import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PlansList = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [newPrice, setNewPrice] = useState('');
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [planss, setPlanss] = useState([]);
  const [partner, setPartner] = useState(null);
  const apiUrl = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
      const fetchPartnerDetails = async () => {
        try {
          const token = localStorage.getItem('token'); // Replace with your actual token key
  
          const response = await axios.get(`${apiUrl}ESIMGOAdmin/partner_details?flag=1`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.data.isSuccess) {
            const partnerCode = localStorage.getItem('selectedPartnerCode');
            const foundPartner = response.data.partnerlist.find(partner => partner.partnercode === partnerCode);
            setPartner(foundPartner);
          } else {
            setError('Failed to fetch partner details');
          }
        } catch (err) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      };
  
      fetchPartnerDetails();
    }, []);
  useEffect(() => {
    const fetchPlans = async () => {
      const selectedPartnerCode = localStorage.getItem('selectedPartnerCode');
      const selectedVendor = localStorage.getItem('selectedVendor');

      try {
        const response = await fetch(`${apiUrl}ESIM/Get_all_plans?flag=2&PartnerCode=${selectedPartnerCode}&vendor_id=${selectedVendor}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        });
        const data = await response.json();

        if (data.isSuccess) {
          setPlans(data.getallplan);
        } else {
          setError('Failed to fetch data');
        }
      } catch (error) {
        setError('An error occurred while fetching the plans');
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, [token]);

  const handleOpenModal = (plan) => {
    setSelectedPlan(plan);
    setNewPrice(plan.sellingcost); // Set the default price to current selling cost
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPlan(null);
    setNewPrice('');
  };

  const handleActionPlan = async (flag, planid) => {
    const selectedPartnerCode = localStorage.getItem('selectedPartnerCode');
    const partnerCode = localStorage.getItem('partnerCode');
    const selectedVendor = localStorage.getItem('selectedVendor');
  
    // If price is being updated, check if the new price is valid and not too low
    if (flag === 2) {
        if (!newPrice || isNaN(newPrice)) {
            setError('Please enter a valid price');
            return;
        }
        
        // Fetch the buying cost for the selected plan
        const buyingCost = parseFloat(selectedPlan.buying_cost);
        const enteredPrice = parseFloat(newPrice);
        
        if (enteredPrice < buyingCost) {
            alert('Price is too low. Cannot set a price lower than the buying cost.');
            return;
        }
    }
  
    const planData = {
        flag: flag, // Use flag 2 for price update, flag 1 for inactivation
        partnercode: selectedPartnerCode,
        plan_id: flag === 1 ? planid : selectedPlan.planid, // For removing, use passed planid
        vendor_id: selectedVendor,
        price: flag === 2 ? newPrice : '', // Only include price if flag is 2
        updatedby: partnerCode,
    };
  
    try {
        const response = await fetch(`${apiUrl}ESIMGOAdmin/Update_plan_status`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(planData),
        });
  
        const result = await response.json();
  
        if (result.isSuccess) {
            if (flag === 2) {
                // If price was updated, update the price in the plan list
                setPlans((prevPlans) => prevPlans.map((plan) =>
                    plan.planid === selectedPlan.planid ? { ...plan, sellingcost: newPrice } : plan
                ));
            }
            handleCloseModal();
            alert(flag === 2 ? 'Price updated successfully!' : 'Plan Hidden Successfully!');
        } else {
            setError('Failed to update the plan');
            alert('Failed to update the plan!');
        }
    } catch (error) {
        setError('An error occurred while updating the plan');
        alert('An error occurred while updating the plan!');
    }
};

  



  useEffect(() => {
    // Fetch the plans data from the API
    const fetchPlanss = async () => {
      const token = localStorage.getItem('token'); // Retrieve the token from localStorage
      const selectedPartnerCode = localStorage.getItem('selectedPartnerCode');
      const selectedVendor = localStorage.getItem('selectedVendor');
      const url = `${apiUrl}ESIMGOAdmin/view_plans_remove_price?flag=2&partnerCode=${selectedPartnerCode}&vendorId=${selectedVendor}`;
      
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`, // Attach the token to the headers
          },
        });

        const data = await response.json();
        if (data.isSuccess) {
          setPlanss(data.mappedplanlist);
        } else {
          setError("Failed to fetch data");
        }
      } catch (error) {
        setError("Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchPlanss();
  }, []);



  const handledelete = async (id) => {
    setLoading(true); // Set loading to true while waiting for the API response

    const token = localStorage.getItem('token'); // Retrieve the token from localStorage
    const url = `${apiUrl}ESIMGOAdmin/delete_mapped_plans`;

    try {
        const response = await fetch(url, {
            method: 'POST', // or 'DELETE' depending on the API's requirement
            headers: {
                'Authorization': `Bearer ${token}`, // Add token in Authorization header
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                flag: 1, // Delete action flag
                id: id // Pass the dynamic ID
            }),
        });

        const data = await response.json();
        
        // Check the response and show the message
        if (data.isSuccess) {
            alert(data.message);
        } else {
            alert('Something went wrong, please try again!');
        }
    } catch (error) {
        console.error('Error:', error);
        alert('There was an error with the request!');
    } finally {
        setLoading(false); // Set loading to false after the request completes
    }
};





  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  if (error) {
    return <div className="text-center py-5 text-red-500">{error}</div>;
  }

  return (
    <div className="mt-4 p-4 justify-between items-center bg-white">
        <div className="flex justify-between ml-4">
     <div className="p-4">
      {partner ? (
        <div className="bg-gray-100  shadow-md rounded p-4">
          <h2 className="text-xl font-bold mb-4">Partner Details</h2>
          <p><strong>Company Name:  </strong> {partner.companyname}</p>
          <p><strong>Contact Person:</strong> {partner.contactperson}</p>
          <p><strong>Partner Code:  </strong>{partner.partnercode}</p>
          <p><strong>Partner email:  </strong>{partner.email}</p>


        </div>
      ) : (
        <div>No partner found for the stored partner code.</div>
      )}
    </div>
    <div className="p-4">
      {partner ? (
        <div className="bg-gray-100  shadow-md rounded p-2">
          <h2 className="text-xl font-bold mb-4">Partner Information</h2>
      
          <p><strong>Balance:</strong> ${partner.balance}</p>
          <p><strong>Discount:</strong> {partner.discount}%</p>

          <p><strong> Type:  </strong>{partner.role}</p>

        </div>
      ) : (
        <div>No partner found for the stored partner code.</div>
      )}
    </div>
</div>
      <h1 className="text-5xl font-semibold mb-4">Available Plans</h1>
      <table className="min-w-full bg-white">
        <thead>
          <tr>
            <th className="py-2 px-4 text-center border-b">Plan Name</th>
            <th className="py-2 px-4 text-center border-b">Country</th>
            <th className="py-2 px-4 text-center border-b">Data</th>
            <th className="py-2 px-4 text-center border-b">Validity</th>
            <th className="py-2 px-4 text-center border-b">Buying Price</th>
            <th className="py-2 px-4 text-center border-b">Selling Price</th>
            <th className="py-2 px-4 text-center border-b">Plan ID</th>
            <th className="py-2 px-4 text-center border-b">Operator</th>
            <th className="py-2 px-4 text-center border-b">Price</th>
            <th className="py-2 px-4 text-center border-b">Status</th>
          </tr>
        </thead>
        <tbody>
          {plans.length === 0 ? (
            <tr>
              <td colSpan="8" className="py-4 px-4 text-center text-red-500 font-semibold">
                Sorry, no plans are available or active.
              </td>
            </tr>
          ) : (
            plans.map((plan,index) => (
              <tr key={plan.planid}>
                                <td className="py-2 px-4 text-center border-b">{index + 1}</td>
                <td className="py-2 px-4 text-center border-b">{plan.planname}</td>
                <td className="py-2 px-4 text-center border-b">{plan.country}</td>
                <td className="py-2 px-4 text-center border-b">{plan.data}</td>
                <td className="py-2 px-4 text-center border-b">{plan.validity}</td>
                <td className="py-2 px-4 text-center border-b">${parseFloat(plan.buying_cost).toFixed(2)}</td>
                <td className="py-2 px-4 text-center border-b">${plan.sellingcost}</td>
                <td className="py-2 px-4 text-center border-b">{plan.planid}</td>
                <td className="py-2 px-4 text-center border-b">{plan.operatorname || 'N/A'}</td>
                <td className="py-2 px-4 text-center border-b">
                  <button
                    onClick={() => handleOpenModal(plan)}
                    className='rounded-full px-6 py-2 font-semibold text-white shadow-md hover:bg-white transition duration-200 ease-in'
                    style={{ background: 'linear-gradient(to bottom right, #27d0b6, #24c8b5, #1bb1af, #18a8ad)' }}
                  >   
                    Edit Price
                  </button>
                </td>
                <td className="py-2 px-4 text-center border-b">
                <button
                onClick={() => handleActionPlan(1, plan.planid)} // Pass the planid when removing the plan
                className='rounded-full px-6 py-2 font-semibold text-white shadow-md hover:bg-white transition duration-200 ease-in'
                style={{ background: 'linear-gradient(to bottom right, #27d0b6, #24c8b5, #1bb1af, #18a8ad)' }}
              >
                Hide Plan
              </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Modal for Updating Price */}
      {showModal && selectedPlan && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg w-1/3">
            <h2 className="text-2xl font-semibold mb-4">Update Price for {selectedPlan.planname}</h2>
            
            {/* Displaying all plan details */}
            <div className="mb-4">
              <p><strong>Plan Name:</strong> {selectedPlan.planname}</p>
              <p><strong>Country:</strong> {selectedPlan.country}</p>
              <p><strong>Data:</strong> {selectedPlan.data}</p>
              <p><strong>Validity:</strong> {selectedPlan.validity}</p>
              <p><strong>Buying price:</strong>${parseFloat(selectedPlan.buying_cost).toFixed(2)}</p>
              <p><strong>Selling Price:</strong> ${selectedPlan.sellingcost}</p>
              <p><strong>Plan Id</strong> {selectedPlan.planid}</p>
              <p><strong>Operator:</strong> {selectedPlan.operatorname || 'N/A'}</p>
            </div>
            
            {/* New Price Input */}
            <div className="mb-4">
              <label htmlFor="newPrice" className="block text-sm font-medium text-gray-700">
                New Price
              </label>
              <input
                type="number"
                id="newPrice"
                value={newPrice}
                onChange={(e) => setNewPrice(e.target.value)}
                className="w-full mt-2 p-2 border border-gray-300 rounded-md"
                required
              />
            </div>
            
            <div className="flex justify-end space-x-4">
              <button
                onClick={handleCloseModal}
                className="px-4 py-2 bg-gray-300 text-black rounded-md hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={() => handleActionPlan(2)} // Flag 2 for updating the price
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
              >
                Update Price
              </button>
            </div>
          </div>
        </div>
      )}
        <div className="container mx-auto px-4">
      <h1 className="text-2xl font-bold mb-4">Plan List</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border-collapse border border-gray-200">
          <thead>
            <tr className="bg-gray-100">
            <th className="px-4 py-2 border border-gray-300 text-left">Id</th>
            <th className="px-4 py-2 border border-gray-300 text-left">plan_id</th>
              <th className="px-4 py-2 border border-gray-300 text-left">Plan Name</th>
              <th className="px-4 py-2 border border-gray-300 text-left">Status</th>
              <th className="px-4 py-2 border border-gray-300 text-left">Price (USD)</th>
              <th className="px-4 py-2 border border-gray-300 text-left">Created Date</th>
              <th className="px-4 py-2 border border-gray-300 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
          {plans.length === 0 ? (
            <tr>
              <td colSpan="8" className="py-4 px-4 text-center text-red-500 font-semibold">
               Updated plans and deleted plans will be displayed here.
              </td>
            </tr>
          ) : (
           planss.map((plan) => (
              <tr key={plan.id} className="odd:bg-white even:bg-gray-50">
                 <td className="px-4 py-2 border border-gray-300">{plan.id}</td>
                 <td className="px-4 py-2 border border-gray-300">{plan.plan_id}</td>
                <td className="px-4 py-2 border border-gray-300">{plan.plan_name}</td>
                <td className="px-4 py-2 border border-gray-300">{plan.status}</td>
                <td className="px-4 py-2 border border-gray-300 text-blue-500">${plan.price}</td>
                <td className="px-4 py-2 border border-gray-300">{plan.createddate}</td>
                <td className="px-4 py-2 border border-gray-300">
              <button
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                  onClick={() => handledelete(plan.id)} // Pass the dynamic plan.id
                  disabled={loading}
              >
                  {loading ? 'Loading...' : 'Revoke '}
              </button>
          </td>

            </tr>
          ))
        )}
          </tbody>
        </table>
      </div>
    </div>
    </div>

  );
};

export default PlansList;
